import React, { useEffect } from 'react';
import { Badge } from 'react-bootstrap';

import useGlobal from '../../../../store';
import Table from '../../../../facturotopia/table/Table';
import ReceptoresExcelStatus from '../enum/ReceptoresExcelStatus';

const mapState = (store) => {
  return store.app.receptores.excel;
};

const mapActions = (actions) => {
  return { ...actions.app.receptores.excel };
};

const ReceptoresExcelList = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);
  const { busy, data } = state;

  useEffect(() => {
    if (data.length === 0) {
      actions.paginate({
        page: 1,
      });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const paginate = (page = 1) => {
    actions.paginate({
      page,
    });
  };

  const handleOnPageChange = (page) => {
    paginate(page);
  };

  const getPaginationConfig = () => {
    const { pagination } = state;

    return {
      metadata: pagination,
      onPageChange: handleOnPageChange,
    };
  };

  const { onRowClick } = props;

  return (
    <Table
      loading={busy}
      columns={columns}
      rowKey={'id'}
      data={data}
      selectable={true}
      pagination={getPaginationConfig()}
      onRow={onRowRender}
      onRowClick={onRowClick}
    ></Table>
  );
};

const renderStatus = (item) => {
  let variant = 'light';

  const status = ReceptoresExcelStatus.search(item.status);

  if (status?.isValid()) {
    variant = 'success';
  } else if (status?.isError()) {
    variant = 'danger';
  } else if (status?.isUpdated()) {
    variant = 'info';
  }

  return <Badge variant={variant}>{status?.getName()}</Badge>;
};

const onRowRender = (item) => {
  return {
    className: item.highlight ? 'row-highlighted' : '',
  };
};

const columns = [
  {
    key: 'created_at',
    title: 'Fecha',
    dataIndex: 'created_at',
  },
  {
    key: 'rfc',
    title: 'RFC',
    dataIndex: 'rfc',
  },
  {
    key: 'razon_social',
    title: 'Razón Social',
    dataIndex: 'razon_social',
  },
  {
    key: 'uso_cfdi',
    title: 'Uso CFDI',
    dataIndex: 'uso_cfdi',
  },
  {
    key: 'regimen',
    title: 'Régimen',
    dataIndex: 'regimen',
  },
  {
    key: 'email',
    title: 'Email',
    dataIndex: 'email',
  },
  {
    key: 'status',
    title: 'Status',
    dataIndex: 'status',
    render: renderStatus,
  },
];

export default ReceptoresExcelList;
